import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-expand-lg bg-secondary text-uppercase fixed-top",
  id: "mainNav"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "navbar-brand",
  href: "#app"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Jan Pilař")
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler navbar-toggler-right text-uppercase font-weight-bold bg-primary text-white rounded",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarResponsive",
  "aria-controls": "navbarResponsive",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createTextVNode(" Menu "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" })
], -1)
const _hoisted_7 = {
  class: "collapse navbar-collapse",
  id: "navbarResponsive"
}
const _hoisted_8 = { class: "navbar-nav ml-auto" }
const _hoisted_9 = { class: "nav-item mx-0 mx-lg-1" }
const _hoisted_10 = {
  class: "nav-link py-3 px-0 px-lg-3 rounded",
  href: "#portfolio"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Projekty")
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "nav-item mx-0 mx-lg-1" }
const _hoisted_14 = {
  class: "nav-link py-3 px-0 px-lg-3 rounded",
  href: "#about"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("O mně")
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_smooth_scroll = _resolveDirective("smooth-scroll")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("a", _hoisted_3, _hoisted_5, 512), [
        [_directive_smooth_scroll]
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          _createElementVNode("li", _hoisted_9, [
            _withDirectives(_createElementVNode("a", _hoisted_10, _hoisted_12, 512), [
              [_directive_smooth_scroll]
            ])
          ]),
          _createElementVNode("li", _hoisted_13, [
            _withDirectives(_createElementVNode("a", _hoisted_14, _hoisted_16, 512), [
              [_directive_smooth_scroll]
            ])
          ])
        ])
      ])
    ])
  ]))
}